import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/monorepo/monorepo/apps/website/components/pages/sign-up/fresh/CatNames/CatNames.tsx");
